import React from "react";
import { Box, Button, Text } from "@chakra-ui/react";

type Props = {
  children: React.ReactNode;
};

type State = {
  hasError: boolean;
  error?: Error;
};

class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("Erro capturado pelo ErrorBoundary:", error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box p={8} bg="red.50" borderRadius="md" textAlign="center">
          <Text fontSize="xl" fontWeight="bold" color="red.600">
            Ocorreu um erro inesperado 😥
          </Text>
          <Text mt={2} color="gray.700">
            Por favor, tente novamente ou recarregue a página.
          </Text>
          <Button mt={4} colorScheme="red" onClick={this.handleReload}>
            Recarregar
          </Button>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
